/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum BatchSizeUnit {
  G = "g",
  KG = "kg",
  OZ = "oz",
  LB = "lb",
}
